import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { VehicleModel, buildModelYearsPath } from 'client/data/models/vehicle-v2';
import { getPageLinksPath, LinkWidgetsModel } from 'client/data/models/link-widgets';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getIncentivesMakeBreadcrumbs } from 'client/site-modules/incentives/utils/breadcrumbs';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { updateVehicle } from 'client/actions/vehicle';
import { IncentivesMake } from './incentives-make';

export const pageDefinitionConfiguration = ({ make }) => ({
  name: 'car_incentives_make',
  category: 'car_incentives',
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`makes`, VehicleModel);
    preloader.resolve(buildModelYearsPath(make), VehicleModel);
    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);

    store.dispatch(updateVehicle({ make: { niceName: make } }));

    return preloader.load();
  },
  seo: state => {
    const modelState = getModelState(state);
    const makeName = modelState.get(`makes.${make}.name`, VehicleModel);
    return {
      title: `${makeName} Tax Credits, Rebates and Incentives - ${makeName} Discounts | Edmunds`,
      description: `Browse the latest ${makeName} Tax Credits, Rebates and Incentives in your area at Edmunds.com. Find the best ${makeName} discounts and current offers.`,
      keywords: `${makeName} Incentives Rebates`,
      jsonld: [getBreadcrumbSchema(getIncentivesMakeBreadcrumbs(makeName))],
    };
  },
  component: () => <IncentivesMake makeSlug={make} />,
  options: {
    hasVehicleContext: true,
  },
});

export default params => pageDefinition(pageDefinitionConfiguration(params));
